export enum Locales {
  EnGB = 'en-GB', // only used for testing for MVP
  EnUS = 'en-US'
}
